import { restClient } from '@/Core'

import { adminPath } from './diskAdminApi'

import type { DiskAdminStorageCard } from '../Contracts/DiskAdmin'

type RawCard = Omit<DiskAdminStorageCard, 'permissions'> & { _permissions?: Record<string, boolean> }

/**
 * Картка простору: `GET /services/disk/admin/storages/{uuid}`. На активному
 * «Моєму диску» бек не віддає `topFolders`/`rootFiles` зовсім
 * (`contentVisible: false`) — фронт нічого не ховає, ховати нічого.
 */
export const LoadDiskAdminStorageTask = async (uuid: string): Promise<DiskAdminStorageCard> => {
    const { _permissions: permissions, ...card } = (await restClient.get(
        adminPath('storages', uuid),
        {},
        { forceRefresh: true }
    )) as unknown as RawCard

    return { ...card, permissions: { quota: permissions?.['quota'] === true, content: permissions?.['content'] === true } }
}
